var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoR4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 121,
    viewBox: "0 0 175 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.604 43.5146V43.5488C219.265 51.4128 215.06 58.4684 208.343 62.4189C194.156 70.6776 167.311 86.3321 143.479 100.266L121.232 113.288C113.105 118.036 104.015 120.431 94.9043 120.431C87.2951 120.431 79.6643 118.765 72.5889 115.412L7.54785 77.9844C3.76594 75.7978 1.96463 72.3526 1.13965 68.6104C0.311106 64.8516 0.4784 60.8414 0.608398 57.5811V14.8975L88.8584 68.1367C93.4229 70.9104 99.1291 70.9108 103.693 68.1367C130.286 51.993 215.659 2.67464 216.552 2.16113L218.176 1.22754H218.151L218.799 0.854492L219.604 43.5146Z",
    stroke: "#434D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoR4);
export default __webpack_public_path__ + "static/media/logo-r-4.bcb6b1478667d65aa7933e98e115388b.svg";
export { ForwardRef as ReactComponent };